module.exports = __webpack_public_path__ + "img/ic_aidprint.4f8991b6.png";